import { OptionGroupLinkStatus } from '@/types';
import { BadgeVariant } from '@ygtechnologies/rubus-ui';

export function getPillVariant(status: OptionGroupLinkStatus): BadgeVariant {
    switch (status) {
        case OptionGroupLinkStatus.Approved:
            return 'success';
        case OptionGroupLinkStatus.Rejected:
            return 'danger';
        case OptionGroupLinkStatus.Pending:
            return 'warning';
        default:
            return 'neutral';
    }
}

